import { type ReactElement, type SVGProps } from 'react';

export const LinkIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.6484 4.26062L10.6816 7.22498L11.3887 7.93201L14.3555 4.96765C15.6445 3.6781 17.7412 3.67956 19.0303 4.96814C19.6553 5.59168 19.999 6.42126 19.999 7.30359C19.999 8.18592 19.6553 9.0155 19.0303 9.63953L16.0644 12.6039L16.7715 13.3114L19.7373 10.3471C20.5508 9.53406 20.999 8.45301 20.999 7.30359C20.999 6.15417 20.5508 5.07312 19.7373 4.26062C18.0586 2.58337 15.3271 2.58142 13.6484 4.26062Z"
        fill="currentColor"
      />
      <path
        d="M9.64257 19.0321C8.35448 20.3192 6.2578 20.3202 4.96777 19.0321C4.34375 18.4081 4 17.578 4 16.6962C4 15.8143 4.34375 14.9843 4.96777 14.3602L7.93359 11.3959L7.22656 10.6888L4.26074 13.6532C3.44726 14.4657 3 15.5468 3 16.6962C3 17.8456 3.44727 18.9266 4.26074 19.7391C5.10058 20.578 6.20215 20.9979 7.30566 20.9979C8.40722 20.997 9.51074 20.578 10.3496 19.7391L13.3164 16.7753L12.6094 16.0682L9.64257 19.0321Z"
        fill="currentColor"
      />
      <path d="M13.4895 10.007L9.84351 13.653L10.5505 14.36L14.1965 10.714L13.4895 10.007Z" fill="currentColor" />
    </svg>
  );
};
